import {getDurationPerImage} from "./duration";
import {getMaxDurationFromBlock} from "./getMaxDurationForBlock";

export const getImageForDuration = (ceremony, block, images, duration, isRepeating) => {
    if (!block) {
        return null;
    }

    const maxDuration = getMaxDurationFromBlock(ceremony, block, isRepeating);

    if (maxDuration <= 0 || duration <= 0) {
        return 0;
    }

    const maxIndex = images.length - 1;

    if (duration >= maxDuration) {
        return maxIndex;
    }

    const filesBlock = (block.parent_block ? block.parent_block : block);
    const durationPerImage = Number(getDurationPerImage(block, (filesBlock.original_files || filesBlock.files || []).filter(file => !!file.song)));

    if (durationPerImage <= 0) {
        return 0;
    }

    const imageIndex = Math.floor(duration / durationPerImage);

    if (imageIndex > maxIndex) {
        const setting = block.settings.find(setting => setting.name === 'repeat_photos');
        const parentBlock = block.parent_block ? block.parent_block : block;

        if (setting && setting.value === '1' || isRepeating || (parentBlock?.songs_override_id && parentBlock.songs_override_id !== parentBlock.id)) {
            const imageGroupDuration = durationPerImage * images.length;
            const groupsDone = Math.floor(duration / imageGroupDuration);
            const groupDuration = Math.floor(duration - (imageGroupDuration * groupsDone));

            return Math.floor(groupDuration / durationPerImage);
        }

        return maxIndex;
    }

    return imageIndex;
}

export default getImageForDuration
